/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  codigoFicha?: string;
  idLeadCorretor?: string;
  idUnidade?: string;
  idOportunidade?: string | null;
}
export function useGetCodigoFicha(props: Props) {
  const searchParams = new URLSearchParams();

  if (props.idOportunidade) {
    searchParams.append("idOportunidade", props.idOportunidade);
    if (props.codigoFicha)
      searchParams.append("codigoFicha", props.codigoFicha);
  } else if (props.codigoFicha) {
    searchParams.append("numeroFicha", props.codigoFicha);
  }

  if (props.idUnidade) searchParams.append("idUnidade", props.idUnidade);
  if (props.idLeadCorretor)
    searchParams.append("idLeadCorretor", props.idLeadCorretor);

  const GET_FICHA = `${backofficeEnviroment}/common/oportunidades-lead/ficha/v1?${searchParams.toString()}`;
  const fetchData = async () => {
    const response = await instance.get(GET_FICHA);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["get-ficha"],
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 1,
    onSuccess: () => {
      // toast.success("Ficha encontrada com sucesso!");
    },
    onError: (error: any) => {
      notificarErroApi("Erro ao buscar ficha", error);
    },
  });
  return query;
}
